<template>
    <div class="vx-col flex-1">
               <div class=" vx-row flex-1">
                   <div class=" vx-col flex-1" style="padding-left:5px" v-if="$acl.check('admin')">
                      <vs-input :label="$t('CourseFeeToParticipant')" :disabled="true" v-model="CourseRequestModel.CourseFeeChargedToParticipant"  class="mt-5 w-full" name="CourseName"/>
                  </div>
                  <div class=" vx-col flex-1"  v-if="CourseRequestModel.CourseID" style="padding-left:5px">
                  
                      <vs-select :disabled="$acl.check('customertrainee')" autocomplete class="mt-5 w-full" :label="$t('Course') " v-model="CourseRequestModel.CourseID" >
                                <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in courses" />
                                 <vs-select-item  :value="0" :text="$t('OtherCourse')" style="background-color:#352566"/>
                      </vs-select>
                    <span class="text-danger text-sm"  v-show="errors.has('Course')">{{ errors.first('Course') }}</span>
                  </div>
                  <div class=" vx-col flex-1" style="padding-left:5px" v-if="CourseRequestModel.CourseID==0||CourseRequestModel.CourseName">
                      <vs-input :disabled="$acl.check('customertrainee')" :label="$t('Course')" v-model="CourseRequestModel.CourseName"  class="mt-5 w-full" name="CourseName"/>
                  </div>
                </div>
                  <div class=" vx-row flex-1" >
                  <div class=" vx-col flex-1" style="padding-left:5px" v-if="CourseRequestModel.CourseLanguageID">
                      <vs-select :disabled="$acl.check('customertrainee')"  class="mt-5 w-full" :label="$t('CourseLanguage') " v-model="CourseRequestModel.CourseLanguageID" >
                                <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in languages" />
                                 <vs-select-item  :value="0" :text="$t('OtherLanguage')" style="background-color:#352566"/>
                      </vs-select>
                    <span class="text-danger text-sm"  v-show="errors.has('CourseLanguage')">{{ errors.first('CourseLanguage') }}</span>
                  </div>
                  <div class=" vx-col flex-1" style="padding-left:5px" v-if="CourseRequestModel.CourseLanguageID==0||CourseRequestModel.CourseLanguageName||CourseRequestModel.CourseID==0">
                     <vs-input :disabled="$acl.check('customertrainee')" :label="$t('CourseLanguagName')" v-model="CourseRequestModel.CourseLanguageName"  class="mt-5 w-full" name="CourseLanguageName"/>
                  </div>
                </div>


                <div class=" vx-row flex-1" style="padding-left:5px"> 
                   <div class=" vx-col flex-1" style="padding-left:5px;padding-top:15px" v-show="CourseRequestModel.CustomerID" v-if="$acl.check('admin')">
                     <p>{{$t('Organization')}}</p>
                                      <v-select
                                      :disabled="$acl.check('customertrainee')"
                                          label="FullName"
                                          class="mb-5 w-full"
                                            
                                            autocomplete
                                          v-model="CourseRequestModel.CustomerID"
                                          :options="customers"
                                          :reduce="ID => ID.ID"
                                        />
                  
                    <span class="text-danger text-sm"  v-show="errors.has('Customer')">{{ errors.first('Customer') }}</span>
                </div>
                  <div class=" vx-col flex-1" style="padding-left:5px;padding-top:15px" v-show="CourseRequestModel.TraineeID" v-if="$acl.check('admin')">
                     <p>{{$t('Trainee')}}</p>
                                      <v-select
                                      :disabled="$acl.check('customertrainee')"
                                          label="FullName"
                                          class="mb-5 w-full"
                                            
                                            autocomplete
                                          v-model="CourseRequestModel.TraineeID"
                                          :options="trainees"
                                          :reduce="ID => ID.ID"
                                        />
                     
                    <span class="text-danger text-sm"  v-show="errors.has('Trainee')">{{ errors.first('Trainee') }}</span>
                </div>
                <div class="vx-col flex-1" style="padding-left:5px" v-show="CourseRequestModel.CustomerID" >
                    <vs-input :disabled="$acl.check('customertrainee')" :label="$t('NoOfTrainee')" v-model="CourseRequestModel.NoOfTrainee" type="number" class="mt-5 w-full" name="NoOfTrainee"  />
                        <!-- <span class="text-danger text-sm" v-show="errors.has('NoOfAids')">{{ errors.first('NoOfAids') }}</span>         -->
                </div>
               </div>
           <div class=" vx-row flex-1" style="padding-left:5px">
               <div class=" vx-col flex-1" style="padding-left:5px;padding-top:20px ">
                  <label>{{$t('RequestStartDate')}}</label> 
                  <datepicker :disabled="$acl.check('customertrainee')" name="Request Start Date" format="yyyy-MM-dd" v-model="CourseRequestModel.RequestStartDate" v-bind:v-validate="{required: true, date_format: 'YYYY-MM-DD'}"></datepicker>
                  <span class="text-danger text-sm"  v-show="errors.has('RequestStartDate')">{{ errors.first('RequestStartDate') }}</span>
               </div>
                <div class=" vx-col flex-1" style="padding-left:5px;padding-top:20px">
                  <p>{{$t('PaymentType')}}</p>
                                      <v-select
                                      :disabled="$acl.check('customertrainee')"
                                          label="Name"
                                          class="mb-5 w-full"
                                            
                                            autocomplete
                                          v-model="CourseRequestModel.PaymentTypeID"
                                          :options="PaymentTypes"
                                          :reduce="ID => ID.ID"
                                        />
                   
                  <span class="text-danger text-sm"  v-show="errors.has('PaymentType')">{{ errors.first('PaymentType') }}</span>
                </div>
           </div>
          <div class="vx-row" >
            <div class="vx-col flex-1" >
               <p>{{$t('CourseType')}}</p>
                                      <v-select
                                      :disabled="$acl.check('customertrainee')"
                                          label="Name"
                                          class="mb-5 w-full"
                                            
                                            autocomplete
                                          v-model="CourseRequestModel.CourseTypeID"
                                          :options="getCourseType"
                                          :reduce="ID => ID.ID"
                                        />
           
            <span class="text-danger text-sm"  v-show="errors.has('CourseMode')">{{ errors.first('CourseMode') }}</span>
        </div>
         <div class="vx-col flex-1" >
              <p>{{$t('RequestLocation')}}</p>
                                      <v-select
                                      :disabled="$acl.check('customertrainee')"
                                          label="Name"
                                          class="mb-5 w-full"
                                            
                                            autocomplete
                                          v-model="CourseRequestModel.RequestLocationID"
                                          :options="RequestLocations"
                                          :reduce="ID => ID.ID"
                                        />
             
            <span class="text-danger text-sm"  v-show="errors.has('RequestLocation')">{{ errors.first('RequestLocation') }}</span>
        </div>
 <div class="vx-col flex-1" v-if="CourseRequestModel.RequestLocationID==1">
            <p> {{$t('Location')}}</p>

           <vs-input  v-model="CourseRequestModel.LocationText"  class="w-full" name="LocationText"/>           
            <span class="text-danger text-sm"  v-show="errors.has('LocationText')">{{ errors.first('LocationText') }}</span>
        </div>
         
             </div>
           </div>
</template>
<script>
import moduleCourse from "@/store/course/moduleCourse.js";
import modulePaymentType from "@/store/settings/paymentType/modulePaymentType.js";
import moduleRequestLocation from "@/store/settings/requestLocation/moduleRequestLocation.js";
import moduleLanguage from "@/store/settings/language/moduleLanguage.js";
import Datepicker from 'vuejs-datepicker';
import moduleCourseType from "@/store/settings/courseType/moduleCourseType.js";
import vSelect from 'vue-select';
export default {
    components:{
       Datepicker,
       vSelect
    },
    data(){
         return{
              CustomerTraineeSwitch:2,
         }
    },
      watch:{
        CustomerTraineeSwitch(val)
        { 
          debugger
          if(val==2)
          {
            this.CourseRequestModel.TraineeID=null;
          }
          else
          {
            this.CourseRequestModel.CustomerID=null;
            this.CourseRequestModel.NoOfTrainee=null;
          }
        }
  },
    props:{
        CourseRequestModel:{
            type:Object,
            required:true
        },
        
    },
    methods(){

    },
    computed:{
       getCourseType()
    {
        return this.$store.state.courseTypeList.courseTypes;
    },
       trainees() {
      return this.$store.state.traineeList.trainees;
    },
    customers() {
      return this.$store.state.customerList.customers;
    },
       courses() {
        return this.$store.state.courseList.courses;
        },
        PaymentTypes() {
         return this.$store.state.PaymentTypeList.PaymentTypes;
        },
        RequestLocations() {
          return this.$store.state.RequestLocationList.RequestLocations;
        },
    
        languages() {
          return this.$store.state.languageList.languages;
        },  
    },
    created()
    {
         if (!moduleCourse.isRegistered) {
      this.$store.registerModule("courseList", moduleCourse);
      moduleCourse.isRegistered = true;
    }
  

    if (!modulePaymentType.isRegistered) {
      this.$store.registerModule("PaymentTypeList", modulePaymentType);
      modulePaymentType.isRegistered = true;
    }
    if(this.$store.state.PaymentTypeList.PaymentTypes.length==0)
       this.$store.dispatch("PaymentTypeList/fetchDataListItems");

    if (!moduleRequestLocation.isRegistered) {
      this.$store.registerModule("RequestLocationList", moduleRequestLocation);
      moduleRequestLocation.isRegistered = true;
    }
     if(this.$store.state.RequestLocationList.RequestLocations.length==0)
       this.$store.dispatch("RequestLocationList/fetchDataListItems");

     if (!moduleLanguage.isRegistered) {
      this.$store.registerModule("languageList", moduleLanguage);
      moduleLanguage.isRegistered = true;
    }
    if (!moduleCourseType.isRegistered) {
      this.$store.registerModule("courseTypeList", moduleCourseType);
      moduleCourseType.isRegistered = true;
    }
    if(this.$store.state.courseTypeList.courseTypes.length==0)
      this.$store.dispatch("courseTypeList/fetchDataListItems");
    if(this.$store.state.languageList.languages.length==0) 
       this.$store.dispatch("languageList/fetchDataListItems");

      debugger
      if(this.CourseRequestModel.TraineeID!=undefined&&this.CourseRequestModel.TraineeID!=null)
      {
        this.CustomerTraineeSwitch=1;
      }
      else 
        this.CustomerTraineeSwitch=2;
    }
}
</script>